<ui-icon-button
  (click)="open()"
  buttonStyle="tonal"
  class="info-badge"
  icon="truck-fast"
  iconStyle="light"
  matTooltip="Liefertagsinformationen"
  [matTooltipDisabled]="this.isMobile()">
</ui-icon-button>

<ng-template #dialogTemplate>
  <mat-dialog-content>
    <h2>Liefertagsinformationen</h2>

    @if (deliveryWindowResource.isLoading()) {
      <ngx-skeleton-loader
        [theme]="{height: '50px', width: '100%', 'border-radius':'0', 'margin': '0 0 20px 0'}"
        appearance="circle"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{height: '50px', width: '100%', 'border-radius':'0', 'margin': '0 0 20px 0'}"
        appearance="circle"
      ></ngx-skeleton-loader>
    } @else if (deliveryWindowResource.error()) {
      <ui-alert [alert]="{
          theme:'error',
          message:'Es ist ein Fehler beim Laden der Liefertagsinformationen aufgetreten.',
      }">
      </ui-alert>

    } @else {
      <ui-delivery-windows-form [deliveryWindows]="mappedDeliveryWindows()"></ui-delivery-windows-form>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <ui-button mat-dialog-close>Schließen</ui-button>
  </mat-dialog-actions>
</ng-template>
